import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../styles/theme';
import { mediaQuery } from '../../../../styles/helpers';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      border: 'none',
      borderRadius: '32px',
      boxShadow: '0px 1px 4px var(--x-shadow-card)',
      cursor: 'pointer',
      color: 'var(--x-accent-2-1)',
      fontWeight: 600,
      padding: [SpacingsValues.s16, SpacingsValues.s24],

      '&:hover': {
        background: 'var(--x-bg-15)',
      },

      '&[data-selected]': {
        background: 'var(--x-bg-15)',
        boxShadow: 'none',
        cursor: 'default',
      },

      '&[disabled]': {
        color: 'var(--x-text-color-2)',
        background: 'var(--x-bg-2)',
        boxShadow: 'none',
        cursor: 'default',
      },

      [mediaQuery(breakpoints.tablet)]: {
        padding: [SpacingsValues.s12, SpacingsValues.s24],
      },
    },
  }),
  {
    name: 'TabButton',
  },
);

export default useStyles;
